import {Link} from 'react-router-dom';
function FaqCon(){    

    return (
        <>        
            <div className="col-12 mt-6 pt-6indx0 mb-6">
                    <div className='container'>

                        <h1 className="text-center mb-5 fw800">
                            <b>Got Questions?<br/> We've Got Answers</b>
                        </h1>

                        <div className="accordion" id="accordionExample5z">

                            {/* WHAT IS KADHR */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#faq0">
                                        What is Kadhr?
                                    </button>
                                </h2>
                                <div id="faq0" className="accordion-collapse collapse show">
                                    <div className="accordion-body font9">
                                        Kadhr helps businesses turn one-time buyers into repeat customers. 
                                        It connects your sales data, learns what your customers buy, and helps you follow up at the right time with simple, personalized messages.
                                    </div>
                                </div>
                            </div>

                            {/* WHO IS IT FOR */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq1">
                                        Who is Kadhr for?
                                    </button>
                                </h2>
                                <div id="faq1" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Kadhr is built for businesses that rely on repeat customers — like cosmetics shops, perfume stores, pharmacies, and specialty retailers.
                                        <br/><br/>
                                        If customers buy from you more than once, Kadhr helps you bring them back automatically.
                                    </div>
                                </div>
                            </div>

                            {/* HOW IT WORKS */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq_new1">
                                        How does Kadhr actually bring customers back?
                                    </button>
                                </h2>
                                <div id="faq_new1" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Kadhr learns from real customer behavior — not guesses.
                                        <br/><br/>
                                        When it detects that a customer is likely ready to buy again, it prepares a message you can send in one click.
                                        <br/><br/>
                                        You can send it manually or let Kadhr automate it for you.
                                    </div>
                                </div>
                            </div>

                            {/* DATA SOURCES */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq_new2">
                                        Do I need to use Kadhr POS to get started?
                                    </button>
                                </h2>
                                <div id="faq_new2" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        No.
                                        <br/><br/>
                                        You can connect Kadhr to your existing setup:
                                        <ul>
                                            <li>POS systems</li>
                                            <li>Online stores (Shopify, etc.)</li>
                                            <li>Excel or CSV uploads</li>
                                        </ul>
                                        Kadhr works on top of your existing data — no migration required.
                                    </div>
                                </div>
                            </div>

                            {/* FALSE INFERENCE TRUST */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq_new3">
                                        What if Kadhr sends the wrong message to customers?
                                    </button>
                                </h2>
                                <div id="faq_new3" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Kadhr avoids guesswork by learning from repeat purchase patterns — not just one-time orders.
                                        <br/><br/>
                                        Messages are suggestions that you approve, and they are designed to feel natural, not pushy.
                                        <br/><br/>
                                        You’re always in control.
                                    </div>
                                </div>
                            </div>

                            {/* PAYMENTS */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq4">
                                        How do payments work?
                                    </button>
                                </h2>
                                <div id="faq4" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Kadhr supports mobile money, cards, and bank payments.
                                        <br/><br/>
                                        Every transaction is automatically linked to a customer profile, helping you track repeat behavior and revenue.
                                    </div>
                                </div>
                            </div>

                            {/* PRICING */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq3">
                                        What does it cost?
                                    </button>
                                </h2>
                                <div id="faq3" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Kadhr offers flexible pricing. <Link to="/pricing"><b>View Pricing</b></Link>.
                                        <br/><br/>
                                        You can start free and upgrade as your repeat customer base grows.
                                    </div>
                                </div>
                            </div>

                            {/* ROI QUESTION */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq_new4">
                                        Will this actually increase my sales?
                                    </button>
                                </h2>
                                <div id="faq_new4" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Yes — Kadhr focuses on bringing existing customers back.
                                        <br/><br/>
                                        Most businesses lose revenue because customers don’t return.
                                        Kadhr helps you follow up at the right time, increasing repeat purchases.
                                    </div>
                                </div>
                            </div>

                            {/* FEATURES */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq5">
                                        What can I do with Kadhr?
                                    </button>
                                </h2>
                                <div id="faq5" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        With Kadhr you can:
                                        <ul>
                                            <li>Capture sales and customer data</li>
                                            <li>See who is likely to buy again</li>
                                            <li>Send reorder reminders in one click</li>
                                            <li>Run loyalty and engagement campaigns</li>
                                            <li>Track repeat customers and revenue</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* WITHDRAWALS */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq2">
                                        How do withdrawals work?
                                    </button>
                                </h2>
                                <div id="faq2" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                         You’re paid automatically as you make sales. Payouts are settled instantly to your account, with any pending settlements completed within 48 hours.
                                    </div>
                                </div>
                            </div>

                            {/* INTERNATIONAL */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq8">
                                        Can I use Kadhr outside Kenya?
                                    </button>
                                </h2>
                                <div id="faq8" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        Yes. Kadhr supports global payments and can be used by businesses across different countries.
                                    </div>
                                </div>
                            </div>

                            {/* SUPPORT */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#faq9">
                                        What support does Kadhr offer?
                                    </button>
                                </h2>
                                <div id="faq9" className="accordion-collapse collapse">
                                    <div className="accordion-body font9">
                                        We offer support via chat, email, and tutorials.
                                        <br/><br/>
                                        <Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="text-dark">
                                            <b>Watch Tutorials</b>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div> 
        </>
    )
}

export default FaqCon;
